<template>
  <div id="irecordedit" >
    <div class="header">
    <el-row type="flex" justify="center" align="middle" :gutter="8" style="height:100%;">
      <el-col :xs="16" :sm="14" :md="14" :lg="9" class="header-tips">
      <!-- <span class="header-tips"> -->
        <audio id="audioTag" ref="audioTag" class="header-tips-audio" :src="editForm.mediaurl" controls="controls" controlsList="nodownload" oncontextmenu="return false" v-show="editForm.mediaurl">
        您的浏览器不支持 audio 标签。
        </audio>
      <!-- </span> -->
      </el-col>
      <el-col :xs="6" :sm="6" :md="8" :lg="5">
      <span class="header-btn">

        <el-button type="danger" @click="handleAuditFormEdit(newContent)"  :disabled="editForm.done">驳回</el-button>
        <el-upload
          :action="postUrl"
          :data = "editForm.data"
          :multiple="false"
          :show-file-list="false"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          :on-error="handleError"
          :before-upload="handleBeforeUpload"
          :file-list="showMusicFileList"
          ref="uploadTag">
          <el-button type="info" :loading="editForm.uploadloading" :disabled="editForm.done" v-if="editForm.mediaurl">重新上传</el-button>
          <el-button type="info" :loading="editForm.uploadloading" :disabled="editForm.done" v-else>上传录音</el-button>
        </el-upload>
        <el-button type="success" @click="releaseNews(newContent.id)" v-show="editForm.mediaurl" :disabled="editForm.done">发布</el-button>

      </span>
      </el-col>
    </el-row>
    </div>

      <el-row type="flex" justify="center" :gutter="20">
        <el-col :xs="24" :sm="24" :md="22" :lg="14">
          <div class="editor-content">

            <!-- <el-col :span="24" class="el-item"> -->

            <div class="news-box">
                <div class="box-header">
                    <span class="new-type fs-label">{{formatCategory}}</span>
                    <span class="hot-level fs-label">{{formatHotIndex}}</span>
                </div>
                <div class="box-title">
                    <h1 class="fs-title">{{newContent.title}}</h1>
                </div>
                <div class="box-author fs-label" >
                  <span>{{newContent.date}}&nbsp;</span>
                  <span v-if="newContent.editorname">&nbsp;编:{{newContent.editorname}}</span>
                  <span v-if="newContent.hostname">&nbsp;播:{{newContent.hostname}}</span>
                  <span v-else-if="newContent.host">&nbsp;播:{{newContent.host}}</span>
                  <span v-if="newContent.verifiername">&nbsp;审:{{newContent.verifiername}}</span>

                </div>
                <div class="box-content">
                  <el-row type="flex" justify="center" :gutter="20">
                    <el-col :xs="20" :sm="20" :md="12" :lg="10">
                    <img class="box-image" :src="newContent.cover" v-show="newContent.cover"/>
                    </el-col>
                  </el-row>
                  <el-row type="flex" justify="center" :gutter="20">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                    <p class="box-text fs-text">{{newContent.content}}</p>
                    </el-col>
                  </el-row>
                </div>

                <div class="box-source fs-text" >
                  <span>新闻来源:</span>
                  <span>{{formatSourcefrom}}</span>
                </div>
                <div class="box-origin fs-text" >
                  <span>原文地址:</span><a :href="newContent.sourceurl" target="_blank">
                  <span class="link-url">{{newContent.sourceurl}}</span></a>
                </div>

                <div class="box-foot fs-label" >
                  <!-- <div v-for="(lable, index) in formatLabels" :key="index">
                    <span v-if="index === 0">{{lable}}</span>
                    <span v-else>&nbsp;/ {{lable}}</span>
                  </div> -->
                  <span>{{formatLabels2}}</span>
                </div>
            </div>
            </div>
        </el-col>
    </el-row>

    <!--驳回界面-->
    <el-dialog :title="auditFormTitle" v-model="auditFormVisible" :close-on-click-modal="false">
      <el-form :model="auditForm" :rules="auditFormRules" ref="auditForm" label-width="80px">

        <el-form-item label="移动至" prop="state" >
          <el-select v-model="auditForm.state" clearable placeholder="请选择" @change="handleCategoryChange">
            <el-option
              v-for="item in formatAuditType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="原因" prop="tip">
          <el-input
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 60}"
            placeholder="请输入驳回理由，可选。"
            v-model="auditForm.tip">
          </el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="auditFormVisible = false">取 消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">{{auditFormBtn}}</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import { Message } from 'element-ui'
    import { newsType, hotsType, newsPlatform, API_HOST } from '../../config/config'
    import { getNowTime } from '../../utils/com.js'
    // import { markdownEditor } from 'vue-simplemde';
    import '../../static/style/irecord/edit.scss'

    const auditType = {
        "1": "编辑端"
    }

    export default {
        data: function(){
            return {

            fileList3: [],

              headerFolder: 'news/',
              postbFolder: '', //'test/20170720/',
              postUrl: '//res-banma.oss-cn-shanghai.aliyuncs.com/',//'//cloud-news.oss-cn-shanghai.aliyuncs.com/', ////qhfm-res.oss-cn-beijing.aliyuncs.com/',
              cdnPostUrl: '//res.banma.jizhuoyangqing.com/', //'//qhfm-res.oss-cn-beijing.aliyuncs.com/', //'//res.kx.qinghuafm.com/',
              //编辑界面数据
              editForm: {
                done: false,
                fileList: [],//[{name: 'food1.jpeg', mediaurl: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}],
                name: '',
                singer: '',
                mediaurl: null,
                mediasize: null,
                mediaduration: null,
                tags: '华语流行',
                music_id: 0,
                fileMd5: '',
                uploadloading: false,
                data: {
                  "Filename": "${filename}",
                  "key": "${filename}",
                  "policy": "", //"eyJleHBpcmF0aW9uIjoiMjAyMC0wMS0wMVQxMjowMDowMC4wMDBaIiwiY29uZGl0aW9ucyI6W1siY29udGVudC1sZW5ndGgtcmFuZ2UiLDAsMTA0ODU3NjAwMF1dfQ==",
                  "OSSAccessKeyId": "", //"jDdyxW3gfj6DGTGw",
                  "success_action_status": "200",
                  "signature": "", //"W17JU2rndCC/nCoUhhtEzXzdBlo="
                }
              },

              auditFormVisible: false,
              auditFormTitle: '驳回',
              auditFormBtn: '提 交',
              editLoading: false,
              auditForm: {
                id: null,
                state: null,
                tip: null,
              },
              auditFormRules: {
                state: [
                  { required: true, message: '请选择驳回至哪一端', trigger: 'change' }
                ],
                tip: [
                  { required: false, message: '请选择驳回理由', trigger: 'blur' },
                  { min: 0, max: 80, message: '长度在 0 到 80 个字符', trigger: 'blur' }
                ],
              },

              dynamicTags: ['标签一', '标签二', '标签三'],
              inputVisible: false,
              inputValue: '',

              content:'12314214',
            }
        },
        computed: {
          ...mapGetters({
              // 映射 this.newsdata 为 store.getters.newContent
              newContent: 'newContent',
              getOsspolicy: 'getOsspolicy',
              getOsskeyid: 'getOsskeyid',
              getOsssign: 'getOsssign',
              newsdata: 'newsdata',
              newstotal: 'newstotal',
          }),
          formatCategory(){
            return newsType[this.newContent.category] || '';
          },
          formatLabels(){
            return this.newContent.labels.split('#') || [];
          },
          formatLabels2(){
            return this.newContent.labels.split('#').join(' / ') || '';
          },
          formatHotIndex(){
            return hotsType[this.newContent.hotindex+''];
          },
          formatSourcefrom(){
            return this.newContent.sourcefrom || '';
            // return newsPlatform[this.newContent.sourcefrom]|| '';
          },
          formatAuditType(){
            let typelists = [];
            for(let i in auditType){
              let typelist = {}
              typelist.value = i;
              typelist.label = auditType[i];
              typelists.push(typelist);
            }
            console.debug("formatCategory> typelists:%o", typelists);
            return typelists;
          },
          showMusicFileList: function () {
            // `this` points to the vm instance
            if(!this.editForm.mediaurl){
              return [];
            }
            let fo = {};
            fo.url = this.editForm.mediaurl;
            fo.name = fo.url.split('/')[fo.url.split('/').length-1];
            // console.debug("showCycleFileList> fo:%o", fo);
            return [fo];
          }
        },
        created() {
          this.id = this.$route.query.id || '';
          let index = this.$route.query.index || 0;
          this.index = parseInt(index);
          console.debug("created> id:%o, index:%o, newsdata:%o, newstotal:%o", this.id, this.index, this.newsdata, this.newstotal);
          let item = this.reqNewsContent(this.id, this.newsdata);
          console.debug("created> item:%o", item);
          this.updateNewsContent(item);

          console.debug("created> newContent:%o, getOsspolicy:%o, getOsskeyid:%o, getOsssign:%o", this.newContent, this.getOsspolicy, this.getOsskeyid, this.getOsssign);
          if(this.newContent.mediaurl){
            this.editForm.mediaurl = this.newContent.mediaurl;
            this.editForm.mediasize = this.newContent.mediasize;
            this.editForm.mediaduration = this.newContent.mediaduration;
          }
          this.editForm.data['policy'] = this.getOsspolicy;
          this.editForm.data['OSSAccessKeyId'] = this.getOsskeyid;
          this.editForm.data['signature'] = this.getOsssign;
          console.debug("created> editForm:%o", this.editForm);
          if(this.newContent.tip){
            Message({
              showClose: true,
              duration: 0,
              message: `驳回理由: ${ this.newContent.tip }`,
              type: 'warning'
            });
          }
          if(API_HOST !== '//api.banma.jizhuoyangqing.com'){
            this.headerFolder = 'news_test/';
          }
        },
        mounted() {
          // var audio = this.$refs['audioTag'];
          // console.debug("mounted> audio:%o", audio);
          // audio.load();
          // audio.play();
        },
        destroyed(){
          Message.closeAll();
        },
        methods: {
          ...mapActions({
            // 映射 this.editNewsContent() 为 this.$store.dispatch('editNewsContent')
            editNewsContent: 'editNewsContent',
            transferNewsState: 'transferNewsState',
            updateNewsContent: 'updateNewsContent',
            updateNewsDataDone: 'updateNewsDataDone'
          }),
          reqNewsContent(id, datalist) {
            console.debug('reqNewsContent> id:%o, datalist:%o', id, datalist);
            let data = null;
            let hasUser = datalist.some(u => {
              if (u.id === id ) {
                data = JSON.parse(JSON.stringify(u));
                return true;
              }
            });
            console.debug("reqNewsContent> hasUser:%o, data:%o", hasUser, data);
            return data;
          },
          getAudioDuration(file) {
              console.debug("getAudioDuration> file:%o", file);
              var that = this;
              // var audio1=document.getElementById("audioTag");
              // var audio2=document.querySelector('#audioTag');
              var audio = that.$refs['audioTag'];
              if(/^audio/i.test(file.raw.type)){
                  // audio.style.display='block';
                  audio.src= file.url;//that.editForm.mediaurl;//file.url;
                  audio.load();
                  function g(){
                    // isNaN(audio.duration) ? requestAnimationFrame(g):console.info("该歌曲的总时间为："+audio.duration+"秒")
                    if(isNaN(audio.duration)){
                      requestAnimationFrame(g)
                    }else{
                      // audio.play();
                      console.info("该歌曲的总时间为："+ audio.duration +"秒");
                      that.editForm.mediaduration = audio.duration;
                      that.postEditform();
                    }
                  }
                  requestAnimationFrame(g);
              }else{
                  audio.pause();
                  // audio.style.display='none';
                  // alert("请选择音乐文件！");
                  this.$message({
                        message: "请选择音乐文件！",
                        type: 'error'
                    });
              }
          },
          postEditform() {
            var that = this;
            let param = Object.assign({}, this.newContent);
            console.info("postEditform> editForm:%o", this.editForm);
            param.mediaurl = this.editForm.mediaurl;
            param.mediasize = this.editForm.mediasize;
            param.mediaduration = this.editForm.mediaduration;
            console.debug("postEditform> param:%o, newContent:%o", param, this.newContent);
            this.editNewsContent(param).then(
              (resp) => {
                console.debug("editNewsContent> resp:%o", resp);
                that.editForm.uploadloading = false;
                if(resp.code === 0){
                    that.$message({
                        message: resp.msg,
                        type: 'success'
                    })
                    console.debug("editNewsContent> newContent:%o", this.newContent);
                    // this.$router.push({ path: './review',query: { id: this.newContent.id }})
                }else{
                  that.$message({
                        message: resp.msg,
                        type: 'error'
                    });
                }
              }
            );
          },
          handleSuccess(file, fileList) {
            console.debug("handleSuccess> file:%o, fileList:%o", file, fileList);
            let filetype = fileList.name.split(".")[fileList.name.split(".").length-1];
            console.log("filetype:%o", filetype);
            this.editForm.mediaurl = "http:"+ this.cdnPostUrl/*this.postUrl*/ + this.headerFolder + this.postbFolder + this.newContent.id +'.'+ filetype//fileList.name;
            this.editForm.mediasize = fileList.raw.size;
            console.log("handleSuccess> mediaurl:%s, mediasize:%o", this.editForm.mediaurl, this.editForm.mediasize);
            this.getAudioDuration(fileList);
          },
          handleError(file, fileList) {
            // console.log(file, fileList);
            this.editForm.uploadloading = false;
            this.$message({
                  message: '文件上传失败!',
                  type: 'error'
              });
          },
          handleRemove(file, fileList) {
            // console.log(file, fileList);
            this.editForm.mediaurl = '';
            this.editForm.uploadloading = false;
          },
          handlePreview(file) {
            // console.log("handlePreview> file:%o", file);
          },
          calFileMd5(err, md5) {
            //console.debug("calFileMd5> err:%o, md5:o", err, md5);
            if(!err){
              this.editForm.fileMd5 = md5;
              console.log("record md5:%o", this.editForm.fileMd5);
            }
          },
          handleBeforeUpload(file){
            console.debug("handleBeforeUpload> file:%o", file);
            let filetype = file.name.split(".")[file.name.split(".").length-1];
            if(this.newContent.mediaurl){
              let curFolder = this.newContent.mediaurl.split('/');
              console.debug("handleBeforeUpload> curFolder:%o", curFolder);
              this.postbFolder = curFolder[curFolder.length-2] + '/';
            }else{
              let curFolder = getNowTime();
              this.postbFolder = curFolder+'/';
            }
            this.editForm.data["key"] = this.headerFolder + this.postbFolder + this.newContent.id+'.'+filetype;
            console.debug("handleBeforeUpload> headerFolder:%o, postbFolder:%o, key:%o", this.headerFolder, this.postbFolder, this.editForm.data["key"]);

            const isMusic = (file.type === 'audio/mp3')||(file.type === 'audio/wma')||(file.type === 'audio/wav');
            const isLt2M = file.size / 1024 / 1024 < 8;
            let judge = false;

            if (!isMusic) {
              this.$message.error('上传音乐文件只能是 mp3/wma/wav 格式!');
            }
            if (!isLt2M) {
              this.$message.error('上传音乐文件大小不能超过 8MB!');
            }
            judge = isMusic && isLt2M ;
            if(judge){
              this.editForm.uploadloading = true;
              console.debug("handleBeforeUpload> uploadloading:%o", this.editForm.uploadloading);
            }
            return judge;
          },

          releaseNews(id){
            console.debug("releaseNews> id:%o", id);
            let param = {};
            param.id = id;
            param.state = 3;
            param.tip = '';
            this.transferNewsState(param).then(
              (resp) => {
              console.debug("transferNewsState> resp:%o", resp);
                if(resp.code === 0){
                    this.$message({
                        message: resp.msg,
                        type: 'success'
                    })
                    this.editForm.done = true;
                    // console.debug("transferNewsState> newContent:%o", this.newContent);
                    // this.$router.push({ path: './review',query: { id: this.newContent.id }})
                }else{
                  this.$message({
                        message: resp.msg,
                        type: 'error'
                    })
                }
              }
            );

          },

          updateNewsConten() {
            this.id = this.$route.query.id || '';
            let index = this.$route.query.index || 0;
            this.index = parseInt(index);
            // console.debug("created> id:%o, index:%o, newsdata:%o, newstotal:%o", this.id, this.index, this.newsdata, this.newstotal);
            let item = this.reqNewsContent(this.id, this.newsdata);
            // console.debug("created> item:%o", item);
            this.updateNewsContent(item);
          },
          handleCategoryChange(e){
            console.debug("handleCategoryChange> e:%o", e);
          },
          //显示编辑界面
          handleAuditFormEdit(item) {
            console.debug("handleAuditFormEdit> item:%o", item);
            this.auditFormVisible = true;
            this.auditForm.id = item.id;
            this.auditForm.state = '1';
            this.auditForm.tip = '';
          },
          //编辑 or 新增
          editSubmit: function () {
            var that = this;

            that.$refs.auditForm.validate((valid) => {
              if (valid) {
                that.$confirm(`请确认移动至  ${auditType[this.auditForm.state]}  吗？`, '提示', {}).then(() => {
                  that.editLoading = true;
                  that.auditFormBtn = '提交中';
                  console.debug("editSubmit> auditForm:%o", that.auditForm);
                  let param = {};
                  param.id = that.auditForm.id;
                  param.state = that.auditForm.state;
                  param.tip = that.auditForm.tip;
                  that.transferNewsState(param).then(
                    (resp) => {
                    console.debug("editNewsContent> resp:%o", resp);
                      if(resp.code === 0){
                          that.$message({
                              message: resp.msg,
                              type: 'success'
                          })
                          that.editLoading = false;
                          that.btnEditText = '提 交';
                          that.editForm.done = true;
                          let para = {
                            id: param.id,
                            done: true
                          }
                          that.updateNewsDataDone(para);
                          that.updateNewsConten();
                          console.debug("transferNewsState>updateNewsDataDone para:%o", para);
                          that.auditFormVisible = false;
                      }else{
                        that.$message({
                              message: resp.msg,
                              type: 'error'
                          })
                      }
                    }
                  );
                });
              }
            });
          },


        },
        components: {
            // markdownEditor
        }
    }
</script>
<style scoped>
    .editor-btn{
        margin-top: 20px;
    }

    .header{
        background: white;
        /*padding: 0 20%;*/
        height: 60px;
        border: 1px solid #939393;
        /*border-style: solid dotted dashed double;*/
        border-top: none;
        border-left: none;
        border-right: none;
        /*display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;*/
        position: fixed;
        z-index: 1;
        width: 100%;
    }
    .header .header-tips{
      /*font-size: 10px;
      color: #939393;*/
      /*width: 80%;*/
      /*border: 1px solid black;*/
      display: inline-flex;
      flex-direction: row;
      justify-content: flex-start;
    }
    .header .header-tips .header-tips-audio{
      /*border: 1px solid blue;*/
      width: 450px;
    }
    .header .header-btn{
      /*border: 1px solid black;*/
      /*width: 150px;
      display: inline-flex;
      flex-direction: row;
      justify-content: space-between;*/

      /* border: 1px solid black; */
      /* width: 150px; */
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      margin: 8px 0;

    }

    .editor-content{
      /*border: 1px solid blue;*/
      margin: 0 auto;
      /*width: 60%;*/
      /*height: 600px;*/
      padding: 60px 10px;
      background: white;
    }

    .input-new-tag{
      width: 120px;
    }

    .box-author{
      font-size: 10px;
      color: #939393;
      margin-bottom: 10px;
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #20a0ff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }

</style>



// WEBPACK FOOTER //
// edit.vue?10cd7180